import logo from "./logo.svg";
import "./App.css";
import LandingPage from "./Components/LandingPage/About/LandingPage";
import Header from "./Components/Header/Header";
import About from "./Components/About/About";
import Service from "./Components/Service/Service";
import BussinessProblem from "./Components/BussinessProblem/BussinessProblem";
import Choose from "./Components/Choose/Choose";
import Review from "./Components/Review/Review";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <LandingPage/>
      <About/>
      <Service/>
      <BussinessProblem/>
      <Choose/>
      <Review/>
      <Contact/>
      <Footer />
    </div>
  );
}

export default App;
